import { StatusType, datadogLogs } from '@datadog/browser-logs';
import type { Logger } from './logging-types';
import { env } from '@/app/env';

let logger: Logger;

export const cLog = () => {
  if (!logger && env.NEXT_PUBLIC_NODE_ENV === 'production') {
    logger = initLogger();
  }
  return logger ?? console;
};

function initLogger() {
  const jsonLogger = datadogLogs.createLogger('client', {
    level: (process.env.NEXT_PUBLIC_LOG_LEVEL as StatusType) ?? StatusType.info,
  });

  const clientLogger: Logger = {
    debug: logFn.bind(null, 'debug'),
    info: logFn.bind(null, 'info'),
    warn: logFn.bind(null, 'warn'),
    error: logFn.bind(null, 'error'),
  };

  function logFn(method: string, msg: string, obj?: object) {
    const { error, ...rest } = (obj ?? {}) as { error?: Error };
    return jsonLogger[method as keyof Logger](
      msg,
      rest,
      error as Error | undefined
    );
  }

  return clientLogger;
}
